// Stable per-browser key for the anonymous LaunchDarkly context. Generated once
// and persisted in localStorage so LD can bucket each visitor consistently —
// required for percentage rollouts, experiments, and per-visitor funnel
// conversion. (The context stays `anonymous: true`, so it isn't billed as an
// identified context.)

const STORAGE_KEY = 'eh_ld_anon_key';

function uuid(): string {
  try {
    return crypto.randomUUID();
  } catch {
    // crypto.randomUUID throws outside a secure context — fall back to a non-crypto id.
    return `anon-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
  }
}

// Store is injectable so this is unit-testable without touching real localStorage.
// Runs at module-eval before React mounts (main.tsx), so storage access is wrapped:
// a hardened/private-mode browser throws SecurityError on localStorage, which would
// otherwise blank-screen the app. Falls back to a fresh in-memory key (LD bucketing
// is degraded for that session, but the app still boots).
// The store is resolved inside the try: with site data blocked, even touching
// window.localStorage throws, and a default parameter would evaluate before the guard.
export function getOrCreateAnonymousKey(
  store?: Pick<Storage, 'getItem' | 'setItem'>,
): string {
  try {
    const s = store ?? localStorage;
    const existing = s.getItem(STORAGE_KEY);
    if (existing) return existing;
    const id = uuid();
    s.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    return uuid();
  }
}
